export default __webpack_public_path__ + "static/media/1415 cutlery top.4929c594.png";